<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card-box">
          <h4 class="header-title">Add Company</h4>
          <p class="sub-header">
            Fill the form to add
            <code>Company</code>,
            or
            <code>API Partners</code>
            .
          </p>

          <div class="col-md-12">

            <form ref="companyCreate">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Company id</label>
                  <input id="companyId" v-model="company.companyId"
                         type="text" class="form-control"
                         :class="{ 'is-invalid': submitted && $v.company.companyId.$error }"/>
                </div>
                <div class="form-group">
                  <label>Company name</label>
                  <input id="name" v-model="company.name"
                         type="text" class="form-control"
                         :class="{ 'is-invalid': submitted && $v.company.name.$error }"/>
                </div>
                <div class="form-group">
                  <label>Company email</label>
                  <input id="email" v-model="company.email"
                         type="email" class="form-control"
                         :class="{ 'is-invalid': submitted && $v.company.email.$error }"/>
                </div>
                <div class="form-group">
                  <label>Company telephone</label>
                  <input id="telephone" v-model="company.telephone"
                         type="text" class="form-control" maxlength="15"
                         :class="{ 'is-invalid': submitted && $v.company.telephone.$error }"/>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>User type</label>
                  <multiselect v-model="company.partnerType"
                               track-by="id"
                               label="name"
                               placeholder="Select one"
                               :options="company.partnerTypes"
                               deselect-label="Can't remove this value"
                               :searchable="true"
                               :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }"> {{ option.name }} </template>
                  </multiselect>
                </div>
                <div class="form-group">
                  <label>State</label>
                  <multiselect v-model="company.stateValue"
                               :options="company.states"
                               :class="{ 'is-invalid': submitted && $v.company.stateValue.$error }"
                               deselect-label="Can't remove this value"
                               :searchable="true"
                               :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }"> {{ option }} </template>
                  </multiselect>
                </div>
                <div class="form-group">
                  <label>Contact person</label>
                  <input id="contactPerson" v-model="company.contactPerson" type="text"
                         class="form-control"
                         :class="{ 'is-invalid': submitted && $v.company.contactPerson.$error }"/>
                </div>
                <div class="form-group">
                  <label>Contact number</label>
                  <input id="contactNumber" v-model="company.contactNumber"
                         type="text" class="form-control"  maxlength="15"
                         :class="{ 'is-invalid': submitted && $v.company.contactNumber.$error }"/>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label>Address</label>
                  <textarea id="address" v-model="company.address"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && $v.company.email.$error }"></textarea>
                </div>
              </div>
            </form>

            <div class="col-md-6">
              <div class="form-group">
                <button type="submit" class="btn btn-primary" @click="submitForm" >Submit</button>
              </div>
            </div>

          </div>
          <!-- end row -->
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import {
    required,
    email,
    minLength,
    maxLength,
  } from 'vuelidate/lib/validators'

  import { states, partners } from '@views/data'

  import { companiesMethods } from '@state/helpers'

  /**
   * Advanced-form component
   */
  export default {
    page: {
      title: 'Add user',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: {
      Multiselect,
      Layout,
      PageHeader,
    },
    data() {
      return {
        title: 'Add user',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Users',
            href: '/',
          },
          {
            text: 'Create user',
            active: true,
          },
        ],
        errorKeys: {
          companyId: ['Invalid Company Id', 'Enter a valid Company Id'],
          name: ['Invalid name', 'Enter a valid Company name'],
          email: ['Invalid email', 'Enter a valid Company email'],
          telephone: ['Invalid telephone', 'Enter a valid Company telephone'],
          contactPerson: ['Invalid contact person', 'Enter a valid contact person name'],
          contactNumber: ['Invalid contact number', 'Enter a valid contact number'],
          partnerType: ['Invalid partner type', 'Enter a valid partner type'],
          stateValue: ['Invalid state', 'Enter a valid state'],
          address:['Invalid address', 'Enter a valid address']
        },
        company : {
          partnerTypes: partners,
          states: states,
          companyId: '',
          name: '',
          email: '',
          telephone: '',
          contactPerson: '',
          contactNumber: '',
          partnerType: '',
          stateValue: '',
          address:''
        },
        submitted: false,
      }
    },
    validations: {
      company : {
        companyId: { required, minLength: minLength(3), maxLength: maxLength(10) },
        name: { required },
        email: { required, email },
        telephone: { required, minLength: minLength(7), maxLength: maxLength(15) },
        contactPerson: { required },
        contactNumber: { required, minLength: minLength(7), maxLength: maxLength(15) },
        partnerType: { required },
        stateValue: { required },
        address: { required }
      },
    },
    methods : {

      ...companiesMethods,

      submitForm: async function (event) {

        try{
          this.submitted = true

          const telephoneRegex = /^\+[1-9]{1}[0-9]{3,14}$/;

          this.$v.$touch()

          if (!this.$v.$invalid) {

            const {
              companyId,
              email,
              telephone,
              name,
              contactPerson,
              contactNumber,
              address
            } = this.company;

            if(!telephoneRegex.test(telephone)) throw Error('Enter country code in telephone')

            if(!telephoneRegex.test(contactNumber)) throw Error('Enter country code in contact number')

            const { success, message } = await this.createCompany({
              companyId,
              role: this.company.partnerType.id,
              email,
              telephone,
              name,
              contactPerson,
              contactNumber,
              state: this.company.stateValue,
              address
            })

            if(!success) throw Error(message)

            this.$refs.companyCreate.reset()

            this.appToast('Company created', message, 'success')
          }
          else{

            let isError = false
            Object.keys(this.$v.company.$params).forEach(each=>{
              if(this.$v.company[each].$error){
                if(!isError){
                  isError = true
                  this.appToast(this.errorKeys[each][0], this.errorKeys[each][1], 'danger')
                }
              }
            })
          }
        }
        catch (e){

          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
        }
      }
    }
  }
</script>